import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";

export function AddHallModal({ open, onClose, onSave, initial = null }) {
  const NAME_MAX = 100;
  const ADDR_MAX = 250;
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setName(initial?.name || "");
      setAddress(initial?.address || "");
    }
  }, [open, initial]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-black/40 p-4 overflow-y-auto">
      <ToastContainer />

      <div className="w-full max-w-xl rounded-lg bg-white shadow-xl my-8">
        <div className="relative border-b px-5 py-4">
          <div className="text-lg font-semibold text-gray-900">
            {initial?.id ? "Edit Hall" : "Add Hall"}
          </div>
          <button
            type="button"
            aria-label="close"
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 text-2xl"
          >
            ×
          </button>
        </div>

        <div className="space-y-5 px-5 py-5">
          <div className="relative">
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Name <span className="text-red-600">*</span>
            </label>
            <input
              className="h-11 w-full rounded border border-gray-300 px-3 outline-none focus:ring-2 focus:ring-[#123047]"
              placeholder="Enter a hall name"
              value={name}
              onChange={(e) =>
                e.target.value.length <= NAME_MAX && setName(e.target.value)
              }
            />
            <div className="pointer-events-none absolute right-2 top-0 text-xs text-gray-500">
              {name.length} / {NAME_MAX}
            </div>
          </div>

          <div className="relative">
            <label className="mb-1 block text-sm font-medium text-gray-700">Address</label>
            <textarea
              rows={4}
              className="w-full rounded border border-gray-300 px-3 py-2 outline-none focus:ring-2 focus:ring-[#123047]"
              placeholder="Enter hall address / details"
              value={address}
              onChange={(e) =>
                e.target.value.length <= ADDR_MAX && setAddress(e.target.value)
              }
            />
            <div className="pointer-events-none absolute right-2 top-0 text-xs text-gray-500">
              {address.length} / {ADDR_MAX}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between border-t px-5 py-4">
          <button
            type="button"
            className="h-10 rounded border border-gray-300 px-4 text-gray-700 hover:bg-gray-50"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="h-10 rounded bg-[#123047] px-6 text-white hover:bg-[#0b2235] disabled:opacity-60"
            onClick={async () => {
              if (!name.trim()) return toast.error("hall name is required");
              try {
                setSaving(true);
                const result = await onSave({
                  id: initial?.id,
                  name: name.trim(),
                  address: address.trim(),
                });
                onClose();
                return result;
              } catch (err) {
                toast.error(err?.response?.data?.message || err?.message || "Failed to save hall");
              } finally {
                setSaving(false);
              }
            }}
            disabled={saving}
          >
            {saving ? "Saving..." : initial?.id ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddHallModal;
